import { useState, ReactNode } from 'react'
import { useResponsiveEnvironment } from '../../hooks/use-responsive-environment'
import { RangeEstimationDesktop } from './range-estimation-desktop'
import { RangeEstimationMobile } from './range-estimation-mobile'
import { rangeContent } from './range-estimation-content/range-estimation-content'
import styles from './range-estimation.module.css'

export interface RangeEstimationProps {
  children: ReactNode /* The 'click' trigger element that opens the slideup/modal, e.g. icon or label */
  rangeType?: string
}

export const RangeEstimation = ({
  children,
  rangeType = 'default',
}: RangeEstimationProps) => {
  const { isMobile } = useResponsiveEnvironment()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const content = rangeContent[rangeType.toLowerCase()]

  return (
    <>
      <button
        aria-label={'Range information'}
        className={styles.infoButton}
        type="button"
        onClick={(event) => {
          event.stopPropagation()
          setIsModalOpen(true)
        }}
      >
        {/* Allows children to either be represented by the 
        icon from filters or the label from vehicle cards */}
        {children}
      </button>

      {isModalOpen && (
        <>
          {/** Renders the appropriate variant based on the current viewport:
           * - Mobile: slide-up panel
           * - Desktop: modal dialog
           * Structure and behavior are similar, styling/CSS differs between variants.
           **/}
          {isMobile ? (
            <RangeEstimationMobile
              content={content}
              onClose={() => setIsModalOpen(false)}
            />
          ) : (
            <RangeEstimationDesktop
              content={content}
              onClose={() => setIsModalOpen(false)}
            />
          )}
        </>
      )}
    </>
  )
}
